// FETCH ALL SIZE RATION
export const FETCH_SIZE_RATIO_REQUEST = 'FETCH_SIZE_RATIO_REQUEST';
export const FETCH_SIZE_RATIO_SUCCESS = 'FETCH_SIZE_RATIO_SUCCESS';
export const FETCH_SIZE_RATIO_FAILURE = 'FETCH_SIZE_RATIO_FAILURE';

// CREATE SIZE RATION
export const CREATE_SIZE_RATIO_REQUEST = 'CREATE_SIZE_RATIO_REQUEST';
export const CREATE_SIZE_RATIO_SUCCESS = 'CREATE_SIZE_RATIO_SUCCESS';
export const CREATE_SIZE_RATIO_FAILURE = 'CREATE_SIZE_RATIO_FAILURE';

// UPDATE SIZE RATION
export const UPDATE_SIZE_RATIO_REQUEST = 'UPDATE_SIZE_RATIO_REQUEST';
export const UPDATE_SIZE_RATIO_SUCCESS = 'UPDATE_SIZE_RATIO_SUCCESS';
export const UPDATE_SIZE_RATIO_FAILURE = 'UPDATE_SIZE_RATIO_FAILURE';

// FETCH SINGLE STATE OF SIZE RATION
export const FETCH_SINGLE_SIZE_RATIO_REQUEST = 'FETCH_SINGLE_SIZE_RATIO_REQUEST';
export const FETCH_SINGLE_SIZE_RATIO_SUCCESS = 'FETCH_SINGLE_SIZE_RATIO_SUCCESS';
export const FETCH_SINGLE_SIZE_RATIO_FAILURE = 'FETCH_SINGLE_SIZE_RATIO_FAILURE';

// DELETE SIZE RATION
export const DELETE_SIZE_RATIO_REQUEST = 'DELETE_SIZE_RATIO_REQUEST';
export const DELETE_SIZE_RATIO_SUCCESS = 'DELETE_SIZE_RATIO_SUCCESS';
export const DELETE_SIZE_RATIO_FAILURE = 'DELETE_SIZE_RATIO_FAILURE';

export const RESET_SIZE_RATIO_INFO = 'RESET_SIZE_RATIO_INFO';

export const CREATE_SIZE_RATIO_FORM = 'CREATE_SIZE_RATIO_FORM';

export const UPDATE_SIZE_RATIO_FORM = 'UPDATE_SIZE_RATIO_FORM';

export const RESET_SIZE_RATIO_DATA = 'RESET_SIZE_RATIO_DATA';